// @flow
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { makeStyles, useTheme } from '@material-ui/styles';
import Fab from '@material-ui/core/Fab';
import ClosedCaptionIcon from '@material-ui/icons/ClosedCaption';

import DesktopAppInstalledComponent from '../../components/DesktopAppInstalledComponent';
import DesktopAppCaptionsModal from '../scribe/DesktopAppCaptionsModal';

import { updateElectronCaptionMode } from '../../actions';

interface Props {
  isDesktop?: boolean;
  inTwilioCalls: boolean;
  electronCaptionMode: boolean;
  fullScreen: boolean;
  updateElectronCaptionMode: Function;
}

const CCButton = ({ isDesktop, inTwilioCalls, electronCaptionMode, fullScreen, updateElectronCaptionMode }: Props) => {
  const theme = useTheme();
  const { t } = useTranslation();

  const [checkIfDesktopAppInstalled, setCheckIfDesktopAppInstalled] = useState(false);
  const [showDesktopAppCaptionPopup, setShowDesktopAppCaptionPopup] = useState(false);

  const openDesktopAppOrShowModal = () => setCheckIfDesktopAppInstalled(true);

  const desktopAppInstalledOrNot = (isInstalled: boolean) => {
    setCheckIfDesktopAppInstalled(false);

    // Let's show the desktop app popup only if the app is not installed
    if (!isInstalled) {
      setShowDesktopAppCaptionPopup(true);
    }
  };

  if (isDesktop) {
    return (
      <>
        {!electronCaptionMode && !fullScreen && (
          <Fab
            size="small"
            style={{
              width: 56,
              height: 56,
              backgroundColor: theme.palette.ava.navy,
              color: theme.palette.ava.white,
            }}
            onClick={() => updateElectronCaptionMode(true)}
          >
            <ClosedCaptionIcon style={{ fontSize: 36 }} />
          </Fab>
        )}
      </>
    );
  }

  return (
    <>
      <Fab
        size="small"
        style={{
          width: 56,
          height: 56,
          backgroundColor: theme.palette.ava.navy,
          color: theme.palette.ava.white,
        }}
        onClick={openDesktopAppOrShowModal}
      >
        <ClosedCaptionIcon style={{ fontSize: 36 }} />
      </Fab>
      <div style={{ display: 'none' }}>
        {checkIfDesktopAppInstalled && (
          <DesktopAppInstalledComponent desktopAppInstalledOrNot={desktopAppInstalledOrNot} />
        )}
        {showDesktopAppCaptionPopup && (
          <DesktopAppCaptionsModal onClose={() => setShowDesktopAppCaptionPopup(false)} t={t} />
        )}
      </div>
    </>
  );
};

const mapStateToProps = ({
  scribeConversation: { inTwilioCalls },
  scribeTranscriptUI: { electronCaptionMode, fullScreen },
}) => ({
  inTwilioCalls,
  electronCaptionMode,
  fullScreen,
});

const mapDispatchToProps = { updateElectronCaptionMode };

export default connect(mapStateToProps, mapDispatchToProps)(CCButton);
